import React from 'react'
import TradeList from './List'
import { Layout } from 'antd'
import Header from '../Header'

const { Content } = Layout

const Trade = (props) => {
  return (
    <Layout className='layout'>
      <Header item='trade' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <TradeList />
        </div>
      </Content>
    </Layout>
  )
}

export default Trade
